import { render, staticRenderFns } from "./TemplateTasksOverview.vue?vue&type=template&id=015cbc1f&scoped=true&"
import script from "./TemplateTasksOverview.vue?vue&type=script&lang=js&"
export * from "./TemplateTasksOverview.vue?vue&type=script&lang=js&"
import style0 from "./TemplateTasksOverview.vue?vue&type=style&index=0&id=015cbc1f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "015cbc1f",
  null
  
)

export default component.exports